export enum SignatureFormatLevel {
  Unknown = 0,
  NoSignatures = 1,
  B = 2,
  T = 3,
  LT = 4,
  LTA = 5,
}
